import appConfig from "../app.config";

let _generator;
const spotifyService = {
    createGenerator() {
        return new Promise((resolve) => {
            let date = new Date();
            let transformedDate = [
                ('0000' + date.getFullYear()).substr(-4),
                '-',
                ('00' + (date.getMonth() + 1)).substr(-2),
                '-',
                ('00' + date.getDate()).substr(-2),
                ' ',
                ('00' + date.getHours()).substr(-2),
                ':',
                ('00' + date.getMinutes()).substr(-2)
            ].join('');

            _generator = new window['SpotifyGenerator']({
                theme: 'white',
                playlistName: `${appConfig.generated_playlist_name} ${transformedDate}`,
                redirectUri: `${window.location.origin}/${appConfig.callbackUri}`,
                recommendationCount: 100,
                onReady: () => {
                    resolve();
                }
            });
        })      
    },

    isAuthenticated: () => _generator.isAuthenticated(),

    authenticate: () => _generator.authenticate(),

    authenticateAsGuest: () => _generator.authenticateGuest(),

    getUserInfo() {
        return Promise.resolve().then(() => {
            if (!_generator.isAuthenticated()) {
                return;
                // throw 'User must be authenticated to use this feature';
            }
            let currentUserPromise = _generator.getCurrentUser(),
                topGenres = _generator.getTopGenres(),
                topArtists = _generator.getTopArtists();

            return Promise.all([currentUserPromise, topGenres, topArtists]);
        }).catch((err) => {
            err && console.error(err);
            console.error('- Error retrieving user info');
            throw '';
        })        
    },

    getPlaylist: (playlistId, user) => _generator.getPlaylist(playlistId, user),

    getTracks: (ids) => _generator.getTracks(ids),

    generateFromSeeds: (seeds, filters) => _generator.generate(seeds, filters),

    generatePlaylist: (tracks, playlistName) => {
        let data = {};
        return Promise.resolve().then(() => {
            if (!_generator.isAuthenticated()) {
                throw 'User must be authenticated to use this feature';
            }
            return _generator.getCurrentUser();
        })
        .then((currentUser) => {
            data.userId = currentUser.id;
            return _generator.createPlaylist(tracks, null, `${appConfig.generated_playlist_name} - ${playlistName}`);
        })        
        .then((playlist) => {
            data.playlist = playlist;
            return data;
        })
        .catch((err) => {
            err && console.error(err);
            console.error('- Error retrieving user info');
            throw '';
        }) 
    }
}

export default spotifyService;